/** @jsx dom */
import {privateFields, companyFields} from '../utils/form-fields';

const getCompanyFields = props => companyFields({props});
const getPrivateFields = props => privateFields({props});

export {getCompanyFields, getPrivateFields};
